<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column">
      {{ item.id }}
    </td>
    <td class="cabinet__tbody-column">
      <p>{{ activeFrom }}</p>
    </td>
    <td class="cabinet__tbody-column">
      <p>{{ activeTo }}</p>
    </td>
    <td class="cabinet__tbody-column">
      {{ item.name }}
    </td>
    <td class="cabinet__tbody-column">
      {{ item.status }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--actions">
      <div class="actions-container align-center">
        <router-link :to="routerData">
          <button class="action-item tooltip__list-item-img--show" />
        </router-link>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';

export default {
  name: 'GenContractorLotTableItem',
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    ...mapState('appService', ['filterType']),
    activeFrom() {
      return dayjs(this.item.activeFrom).format('DD.MM.YYYY HH:mm');
    },
    activeTo() {
      return dayjs(this.item.activeTo).format('DD.MM.YYYY HH:mm');
    },
    routerData() {
      return { name: 'GenContractorLotDetail', params: { id: this.item.id } };
    },
  },
};
</script>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  gap: 8px;
}

.action-item {
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  appearance: none;
  border: 0;
  background-color: transparent;
}
</style>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  gap: 8px;
}

.action-item {
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  appearance: none;
  border: 0;
  background-color: transparent;
}

.align-center {
  display: flex;
  justify-content: center;
}
</style>
